import { BASEAPIURL } from "./constants";
import Axios from "axios";

// Ensure URL ends with /
const api_url = process.env.REACT_APP_API_URL 
  ? (process.env.REACT_APP_API_URL.endsWith('/') ? process.env.REACT_APP_API_URL : process.env.REACT_APP_API_URL + '/')
  : BASEAPIURL;

class Api {
  getBaseUrl() {
    return api_url;
  }
  getToken() {
    return localStorage.getItem("token");
  }

  getApi() {
    const axiosInstance = Axios.create({
      baseURL: api_url,
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + this.getToken(),
      },
    });
    axiosInstance.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        console.log(error);

        // 401 hatası geldiğinde kullanıcıyı logout yap ve login sayfasına yönlendir
        if (error?.response?.status === 401) {
          // Token geçersiz, localStorage'ı temizle
          localStorage.removeItem("token");
          localStorage.removeItem("permissions");

          // Login sayfasına yönlendir
          window.location.href = "/login";
        }

        return Promise.reject(error);
      }
    );

    return axiosInstance;
  }
  getApiWithoutToken() {
    const axiosInstance = Axios.create({
      baseURL: api_url,
      headers: {
        Accept: "application/json",
      },
    });

    return axiosInstance;
  }
}
export default new Api();
